import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { EventTypeAsNumberEnum } from "@application/common/enums/event-type";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { getAllInvitationCountAsync, getInvitationDatesForByInvitationIdWithPreAccDateAsync, } from "@application/features/invitation/invitationThunk";
import { AdminPageHeader } from "@ui/components/Header/AdminPageHeader";
import { TabTitle } from "@ui/components/tabs/TabTitle";
import { Internals } from "./family-fest/FamilyFest";
import { DirectorsEvent } from "./directors/DirectorsEvent";
import { stack1_5 } from "@ui/style/style";
export const Invitation = () => {
    const location = useLocation();
    const { state } = location;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { invitationCounts } = useAppSelector((state) => state.invitation);
    const { linkVerification } = useAppSelector((state) => state.event);
    const [value, setValue] = useState("1");
    const [selectedEventId, setSelectedEventId] = useState(null);
    const [searchParams, setSearchParams] = useState({
        invitationId: null,
        invitationType: null,
    });
    const resetSearch = useCallback(() => {
        setSearchParams({
            invitationId: null,
            invitationType: null,
        });
    }, []);
    useEffect(() => {
        resetSearch();
        dispatch(getAllInvitationCountAsync())
            .unwrap()
            .then((response) => {
            if (response.invitationCounts.length > 0) {
                setValue("1");
                setSelectedEventId(response.invitationCounts[0].eventId);
            }
        });
    }, []);
    useEffect(() => {
        if (linkVerification?.data?.invitationId)
            dispatch(getInvitationDatesForByInvitationIdWithPreAccDateAsync(linkVerification?.data?.invitationId))
                .unwrap()
                .then((response) => { });
    }, []);
    useEffect(() => {
        if (state?.resetSearch) {
            resetSearch();
            navigate(location.pathname, {
                replace: true,
                state: undefined,
            });
        }
        else if (state?.fromSearch && state?.targetEventId) {
            const tabIndex = invitationCounts?.invitationCounts?.findIndex((event) => event.eventId === state.targetEventId);
            if (tabIndex !== undefined && tabIndex !== -1) {
                setValue((tabIndex + 1).toString());
                setSelectedEventId(state.targetEventId);
                setSearchParams({
                    invitationId: state.targetInvitationId,
                    invitationType: state.targetInvitationType,
                });
                navigate(location.pathname, {
                    replace: true,
                    state: undefined,
                });
            }
        }
    }, [state?.targetEventId, state?.fromSearch, state?.resetSearch]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedEvent = invitationCounts?.invitationCounts[parseInt(newValue) - 1];
        if (selectedEvent) {
            setSelectedEventId(selectedEvent.eventId);
            // Reset search params when changing tabs manually
            setSearchParams({
                invitationId: null,
                invitationType: null,
            });
            // Navigate with resetSearch flag for manual tab change
            navigate(location.pathname, {
                replace: true,
                state: {
                    resetSearch: true,
                    manualTabChange: true,
                },
            });
        }
    };
    const totalInvitations = invitationCounts?.invitationCounts?.reduce((sum, count) => sum + count.invitationCount, 0) || 0;
    return (_jsx("div", { children: _jsxs(TabContext, { value: value, children: [_jsx(AdminPageHeader, { title: `${totalInvitations} Invitations`, actions: _jsx(Box, { sx: { ...stack1_5 }, children: _jsx(TabList, { variant: "scrollable", onChange: handleChange, "aria-label": "invitation tabs", children: invitationCounts?.invitationCounts?.map((event, index) => (_jsx(Tab, { label: _jsx(TabTitle, { number: event.invitationCount, title: event.eventName, value: value, index: String(index + 1) }), value: String(index + 1) }, event.eventId))) }) }) }), invitationCounts?.invitationCounts?.map((event, index) => (_jsx(TabPanel, { value: String(index + 1), children: event.eventType == EventTypeAsNumberEnum.External ? (_jsx(DirectorsEvent, { eventId: event.eventId, searchedInvitationId: searchParams.invitationId, searchInvitationTypeEnum: searchParams.invitationType })) : (_jsx(Internals, { eventId: event.eventId, searchedInvitationId: searchParams.invitationId })) }, event.eventId)))] }) }));
};
